import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { NodeWarning, getWarningText } from "../../common/linqset-model";
import { MODEL_COLOURS } from "../../model-services/model-item-enums";
import { BarData } from "../../charts/bar-chart/bar-chart.component";

@Component({
    selector: 'app-warnings-overview',
    templateUrl: './warnings-overview.html',
    styleUrls: ['warnings-overview.css'],
    standalone: false
})
export class WarningsOverviewComponent implements OnChanges, OnInit {
    @Input() warnings:NodeWarning[]

    data: BarData[];

    @Output() selectBarEvent = new EventEmitter<string>(); 
    
    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["warnings"]) { 
            this.populateData()
        }
    }

    ngOnInit(): void {
        this.populateData()
    }

    populateData() {
        if (!this.warnings || this.warnings.length === 0) return

        this.data = this.warnings.reduce((bd:BarData[], nw:NodeWarning) => {
            nw.warnings.forEach(w => {
                let barData = bd.find(d => d._key === w)
                if (!barData) {
                    barData = new BarData(w, getWarningText(w), [0], [MODEL_COLOURS.ORANGE], [MODEL_COLOURS.DARK_ORANGE])
                    bd.push(barData)
                }
                barData.values[0]++
            })           

            return bd
        }, [])
    }

    handleBarSelection(event) {
        this.selectBarEvent.emit(event)
    }
}